<template>
  <div class="loading-spinner"></div>
</template>

<script>
  export default {};
</script>

<style lang="scss">
  @-webkit-keyframes spin-border {
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes spin-border {
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .loading-spinner {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    vertical-align: text-bottom;
    border: 0.25em solid #ffffff;
    border-right-color: transparent;
    border-radius: 50%;
    -webkit-animation: spin-border 0.75s linear infinite;
    animation: spin-border 0.75s linear infinite;
  }
</style>
